export default {
  MuiBreadcrumbs: {
    styleOverrides: {
      root: {
        color: '#000000'
      }
    }
  }
};
